import React, { Component } from 'react'
import { compose } from 'react-apollo'

import { withGoogleMap, GoogleMap, Circle } from 'react-google-maps'

import PropTypes from 'prop-types'

class Map extends Component {
  static propTypes = {
    defaultZoom: PropTypes.number.isRequired,
    defaultCenter: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number
    }),
    center: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number
    }),
    marker: PropTypes.node,
    createRef: PropTypes.func.isRequired,
    circle: PropTypes.object
  }

  static defaultProps = {
    defaultZoom: 16,
    defaultCenter: {
      lat: 37.7749295,
      lng: -122.41941550000001
    }
  }

  render() {
    const { defaultZoom, defaultCenter, createRef } = this.props

    let marker
    let center
    let circle

    if (this.props.marker) {
      marker = this.props.marker
    }

    if (this.props.circle) {
      circle = (
        <Circle
          center={{ lat: this.props.circle.lat, lng: this.props.circle.lng }}
          radius={this.props.circle.radius}
          {...this.props.circle}
        />
      )
    }

    center = this.props.center || defaultCenter

    return (
      <GoogleMap defaultZoom={defaultZoom} center={center} ref={map => createRef(map)}>
        {circle}
        {marker}
      </GoogleMap>
    )
  }
}

export default compose(withGoogleMap)(Map)



// WEBPACK FOOTER //
// src/components/POIForm/Map.js